const license = {
    not_installed: 'Nessuna licenza installata su questa istanza.',
    invalid_key: 'La chiave di licenza non è valida o è stata manomessa.',
    expired_key: 'La chiave di licenza è scaduta. Ottieni una nuova chiave e installala di nuovo.',
};
export default Object.freeze(license);
